/* eslint-disable */
import React from "react";

import ThemeBox from "../ThemeBox";
import type { ThemeBoxProps } from "../ThemeBox";

export type ThemeBoxWithIconProps = {
  heading: string,
  iconSrc?: string | null
} & ThemeBoxProps

const ThemeBoxWithIcon: React.FC<ThemeBoxWithIconProps> = (props) => (
  <ThemeBox {...props}>
    {
      props.heading
      && (
        <span className="heading">
          {props.iconSrc
            && <img alt="" className={`theme-box-icon ${props.theme}`} src={props.iconSrc} />}
          {props.heading}
        </span>
      )
    }
    {props.children}
  </ThemeBox>
);

export default ThemeBoxWithIcon;
